<h1 mat-dialog-title>{{ data.title || 'Delete' }}</h1>
<div mat-dialog-content class="alert-dialog__content">
    <span>{{ data.message }}</span>
</div>
<div mat-dialog-actions>
    <div class="d-flex align-items-center gap-2">
        <button mat-raised-button color="warn" (click)="delete()">Yes</button>
        <button mat-raised-button color="primary" (click)="close()">No</button>
    </div>
</div>